exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper--1wplH {\n  display: block;\n  width: 100%;\n  padding: 10px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n\n.wrapper--1wplH:not(:last-of-type) {\n  border-bottom: 1px solid #C0C0C0;\n}\n\n.wrapper--1wplH .summary--1al-q {\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  -ms-flex-align: center;\n      align-items: center;\n}\n\n.wrapper--1wplH .summary--1al-q .button--2pciD {\n  max-width: 200px;\n  margin-left: auto;\n}\n\n.wrapper--1wplH .accesses--1xIfa .label--2rB0N {\n  max-width: 100%;\n}\n", ""]);

// exports
exports.locals = {
	"wrapper": "wrapper--1wplH",
	"summary": "summary--1al-q",
	"button": "button--2pciD",
	"accesses": "accesses--1xIfa",
	"label": "label--2rB0N"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"minimize":false,"sourceMap":false,"localIdentName":"[local]--[hash:base64:5]","importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false,"plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js?{"data":"$env: production;","sourceMap":false,"outputStyle":"expanded","precision":10,"includePaths":["/app/node_modules","/app/src"]}!./src/components/list-items/ProcessingRole/ProcessingRole.m.scss
// module id = 1582
// module chunks = 0